"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RECOMMENDED_GENERIC_INDUCTOR_PART_UID = exports.RECOMMENDED_GENERIC_CAPACITOR_PART_UID = exports.RECOMMENDED_GENERIC_RESISTOR_PART_UID = exports.GENERIC_CAPACITOR_PART_UID = exports.GENERIC_INDUCTOR_PART_UID = exports.GENERIC_RESISTOR_PART_UID = exports.GROUND_PORTAL_PART_TERMINAL_UID = exports.GROUND_PORTAL_PART_UID = exports.OFFICIAL_POWER_NET_PORTAL_PART_UID = exports.OFFICIAL_NET_PORTAL_PART_UID = exports.ROUTE_BRANCH_POINT_TERMINAL_UID = exports.ROUTE_BRANCH_POINT_PART_UID = exports.GROUND_TERMINAL_UID = exports.DEFAULT_GROUND_TERMINAL_PART_UID = exports.GENESIS_TERMINAL_TERMINAL_UID = exports.GENESIS_TERMINAL_PART_UID = exports.headVersionName = void 0;
/* eslint-disable etc/no-commented-out-code */
/**
 * The name of the special "head" version of a document that contains all changes, published
 * or not.
 *
 * @deprecated The only feature to ever use HEAD was "receive latest drafts",
 * and it was switched to subscribing to the part document directly to allow for
 * the eventual migration from part versions stored in Firestore to Google Cloud
 * Storage as complete document snapshot. See
 * https://coda.io/d/Planning_dM_phVS_lzg/Q3-1-2024-Snapshots_su0jz9Bz#_lugDN97_.
 * @see LatestDraftsListener.tsx.
 * @see https://coda.io/d/Planning_dM_phVS_lzg/Q3-1-2024-Snapshots_su0jz9Bz#_lugDN97_
 */
exports.headVersionName = "HEAD";
/**
 * System parts are special parts that are defined internally, not by users.
 */
/**
 * NOTE: genesis terminal has undefined usage_count, only a HEAD version, and no
 * document_import_uid
 */
exports.GENESIS_TERMINAL_PART_UID = "835bf3e1-33dd-41bb-a166-c0a31607d645";
exports.GENESIS_TERMINAL_TERMINAL_UID = "111bf4e4-02dd-41bb-a137-c0a32607d321";
exports.DEFAULT_GROUND_TERMINAL_PART_UID = "c2e41937-4268-256c-7ae9-cb8cfb60aed3";
exports.GROUND_TERMINAL_UID = "78e6da6c-8b6b-b7dc-d8fd-bbf3d2e8bf9d";
// NOTE: uncomment and double check if needed
// export const GROUND_TERMINAL_DOCUMENT_UID = "3e8011b3-ce77-6f52-53ec-dd998c77ec09";
/**
 * NOTE: branch point has undefined usage_count, only a HEAD version, and no
 * document_import_uid
 */
exports.ROUTE_BRANCH_POINT_PART_UID = "249f5718-845e-4ddb-ad70-4c9693de81cc";
exports.ROUTE_BRANCH_POINT_TERMINAL_UID = "454b349f-3db1-46cd-b57b-ed3ebc97f010";
exports.OFFICIAL_NET_PORTAL_PART_UID = "8324674a-2826-0848-1f78-bd4b4ee0741b";
// NOTE: uncomment and double check if needed
// export const OFFICIAL_NET_PORTAL_DOCUMENT_UID = "c64eca31-292e-2ad5-9339-42e1d9bbc3b0";
exports.OFFICIAL_POWER_NET_PORTAL_PART_UID = "c051e14d-6a3f-44b2-af4b-d5d3cad95046";
// NOTE: uncomment and double check if needed
// export const OFFICIAL_POWER_NET_PORTAL_DOCUMENT_UID = "77bf794e-9058-4061-8f8d-17d16be9d1fc";
exports.GROUND_PORTAL_PART_UID = "48c0360f-e761-4171-8fb2-80528f3d9148";
// NOTE: uncomment and double check if needed
// export const GROUND_PORTAL_DOCUMENT_UID = "943025a0-c8d4-4de4-8b88-97315594c1e3";
exports.GROUND_PORTAL_PART_TERMINAL_UID = "52f64ac9-5d01-d42d-9ddc-7c616f6aa0c0";
exports.GENERIC_RESISTOR_PART_UID = "b67f50a9-ae5e-10ea-9c3c-d377e2ab3b2d";
exports.GENERIC_INDUCTOR_PART_UID = "181603df-1db7-f7c0-4144-8e265bcbee99";
exports.GENERIC_CAPACITOR_PART_UID = "46707925-236f-106b-e676-afa2757aa1d6";
/**
 * Recommended generic part uids.
 */
exports.RECOMMENDED_GENERIC_RESISTOR_PART_UID = "b67f50a9-ae5e-10ea-9c3c-d377e2ab3b2d";
exports.RECOMMENDED_GENERIC_CAPACITOR_PART_UID = "46707925-236f-106b-e676-afa2757aa1d6";
exports.RECOMMENDED_GENERIC_INDUCTOR_PART_UID = "181603df-1db7-f7c0-4144-8e265bcbee99";
//# sourceMappingURL=constants.js.map